import { Trans } from "@lingui/react/macro";
import { Stack, TableOfContents, Text } from "@mantine/core";
import { useRouterState } from "@tanstack/react-router";
import { useLayoutEffect, useRef } from "react";

interface DocsAsideProps {
  headerHeight: number;
}
export function DocsAside({ headerHeight }: DocsAsideProps) {
  // Matches DocHeading's scrollMarginTop (header + 1rem) so the clicked heading becomes active.
  const offset = headerHeight + 16;
  const pathname = useRouterState({
    select: (s) => s.resolvedLocation?.pathname,
  });
  const reinitializeRef = useRef(() => {});
  // Re-scan headings when navigating between docs pages (content changes, DOM unchanged ref).
  useLayoutEffect(() => {
    reinitializeRef.current();
  }, [pathname]);
  return (
    <Stack gap="xs">
      <Text variant="bodyInfoText">
        <Trans>On this page</Trans>
      </Text>
      <TableOfContents
        style={{
          borderLeft: "1px solid var(--mantine-color-gray-2)",
        }}
        // useScrollSpy only reads offset on mount, so remount when it changes.
        key={offset}
        reinitializeRef={reinitializeRef}
        variant="light"
        color="green"
        size="sm"
        radius="xs"
        scrollSpyOptions={{
          selector: "#docs-table-of-contents :is(h2, h3, h4, h5, h6)",
          offset,
        }}
        getControlProps={({ data }) => ({
          onClick: () =>
            data
              .getNode()
              .scrollIntoView({ behavior: "smooth", block: "start" }),
          children: data.value,
        })}
      />
    </Stack>
  );
}
